import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  createAddItem, createUpdate, createDeleteItem, createCopyItem, createDeleteItemImage, createFinalizeAddItemImage
} from '../actions';
import { createFinalizeUploadFile } from '../actions/file';
import * as actions from '../actions/item';
import {
  createEditServicePopup, createEditArtworkPOPopup,
  createValidateConfirmationPopup, createCopyItemPopup,
  createUploadProductImagePopup, createEditInventoryBreakdownQuantityPopup
} from '../actions/popup';

import ProductItemSummary from './ProductItemSummary';
import ProductArtworkSummary from './ProductArtworkSummary';
import ProductCommentSummary from './ProductCommentSummary';
import ProductItemDetailedSummary from './ProductItemDetailedSummary';
import TitleItemSummary from './TitleItemSummary';
import ServiceItemSummary from './ServiceItemSummary';
import OptionItemSummary from './OptionItemSummary';
import OptionItemDetailedSummary from './OptionItemDetailedSummary';
import CollectionItemSummary from './CollectionItemSummary';
import ArtworkPOItemSummary from './ArtworkPOItemSummary';
import DropdownMenu, { MenuTrigger } from './DropdownMenu';

import { getMostRecentUnlockedOrder, getOrderById } from '../selectors';
import { getProofOptions } from '../selectors/dropdowns';
import { withRouter } from './helpers';
import { getOrderItems } from '../utils/order';
import { AddIcon, CheckmarkIcon, colors, IconButton, InfoIcon, LabeledCheckbox, PresentationCircleIcon, SkubotSpinner, Typography } from '@commonsku/styles';
import ProductSearchCallout from './ProductSearchCallout';
import { ItemListTableHeader, ItemListTHDescription } from './ItemListTableHeader';
import SetBulkMarginPopup from './SetBulkMarginPopup';
import BulkActionBar from './BulkActionBar';
import { bulkUpdateMargin, createLoadOrder } from '../actions/order';
import { MagicIcon } from '@commonsku/styles';
import { aiMockupAndRewriterEnabled, getIdentityUtils, oauth } from '../utils';
import { BulkMockupGeneratorPopup } from './mockup-generator/BulkMockupGeneratorPopup';
import PushToShopifyWarnPopup from './shop/popups/PushToShopifyWarnPopup';
import PushToShopifyPopup from './shop/popups/PushToShopifyPopup';
import { startBulkMockupGeneration, pollBulkMockupJob, resumeBulkMockupJob, readPersistedBulkJobIds, persistBulkJobItems, readBulkJobItems } from '../services/mockupGeneration';
import PushToShopifyErrorPopup from './shop/popups/PushToShopifyErrorPopup';
import PushToShopifyPollBridge from './shop/helpers/PushToShopifyPollBridge';
import { isPODShop } from './shop/helpers/helpers';
import { toast } from 'react-toastify';
import PresentationBuilderPage, { PRESENTATION_BUILDER_AGENT_FLAG, SKUBOT_ENABLED } from './presentation-builder/PresentationBuilderPage';
import { SkuBot } from '@commonsku/design-system';

const BASE_ADD_INDEX = 'BASE_ADD_INDEX';
const SUMMARY_CLASS_MAP = {
  'artwork': {
    'PRODUCT': ProductArtworkSummary,
    'OPTION': ProductArtworkSummary
  },
  'comment': {
    'OPTION': ProductCommentSummary
  },
  'compact': {
    'PRODUCT': ProductItemSummary,
    'SERVICE': ServiceItemSummary,
    'SEPARATOR': TitleItemSummary,
    'OPTION': OptionItemSummary,
    'ARTWORK_PO': ArtworkPOItemSummary
  },
  'grid': {
    'PRODUCT': ProductItemSummary,
    'SERVICE': ServiceItemSummary,
    'SEPARATOR': TitleItemSummary,
    'OPTION': OptionItemSummary,
    'ARTWORK_PO': ArtworkPOItemSummary
  },
  'detailed': {
    'PRODUCT': ProductItemDetailedSummary,
    'SERVICE': ServiceItemSummary,
    'SEPARATOR': TitleItemSummary,
    'OPTION': OptionItemDetailedSummary,
    'ARTWORK_PO': ArtworkPOItemSummary
  },
  'collection-compact': {
    'OPTION': OptionItemSummary,
    'SEPARATOR': TitleItemSummary
  },
  'collection-detailed': {
    'OPTION': CollectionItemSummary,
    'SEPARATOR': TitleItemSummary
  },
  'collection-grid': {
    'OPTION': OptionItemSummary,
    'SEPARATOR': TitleItemSummary
  },
};

function formatCatalogItemsFailureToast(failedIds, fallback = 'Could not add items to the client catalog.') {
  if (!failedIds || typeof failedIds !== 'object') {
    return fallback;
  }
  const countsByMessage = Object.values(failedIds).reduce((acc, msg) => {
    if (typeof msg !== 'string' || !msg.trim()) return acc;
    acc[msg] = (acc[msg] || 0) + 1;
    return acc;
  }, {});
  const lines = Object.entries(countsByMessage).map(([msg, count]) =>
    count > 1 ? `${msg} (${count} items)` : msg
  );
  return lines.length ? lines.join('. ') : fallback;
}

class ItemList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      items: this.getStateItemsfromProps(props),
      dragItem: null,
      hoverIndex: -1,
      selectedItemIds: [],
      showSetBulkMarginPopup: false,
      bulkMockupItems: null,
      showPushToShopifyWarnPopup: false,
      showPushToShopifyErrorPopup: false,
      showPushToShopifyPopup: false,
      isPushingToShopify: false,
      filterSetupRequiredItems: false,
      pollingPushToShopifyStatus: null,
      shopifyPollKey: 0,
      bulkMockupStatus: null, // null | 'processing' | 'completed' | 'failed'
      bulkMockupResult: null, // { generated_item_ids?: string[], failed_items?: Record<string,string> }
      generatingItemIds: new Set(), // item IDs currently being generated in bulk
      addToClientCatalogPhase: 'idle', // 'idle' | 'loading' | 'success'
      clientCatalogId: null,
    };
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.onMoveItem = this.onMoveItem.bind(this);
    this.onDropItem = this.onDropItem.bind(this);
    this.onAddItem = this.onAddItem.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onEditItem = this.onEditItem.bind(this);
    this.onCopyItem = this.onCopyItem.bind(this);
    this.onAddProductItem = this.onAddProductItem.bind(this);
    this.onUpgradeItem = this.onUpgradeItem.bind(this);
    this.hasItem = this.hasItem.bind(this);
    this.handleAddToClientCatalog = this.handleAddToClientCatalog.bind(this);
    this.onOpenPresentationBuilder = this.onOpenPresentationBuilder.bind(this);
  }

  componentDidMount() {
    window.addEventListener('dragend', this.onDragEnd);
    this.onAddItem(BASE_ADD_INDEX);

    if (this.props.parentId && this.props.mockupEnabled) {
      // Eagerly show processing state if there are persisted jobs so there's no
      // flash of "idle" UI while we await the first status check.
      const storedJobIds = readPersistedBulkJobIds(this.props.parentId);
      if (storedJobIds.length > 0) {
        const restoredItemIds = storedJobIds.flatMap(jobId => readBulkJobItems(jobId));
        this.setState({
          bulkMockupStatus: 'processing',
          generatingItemIds: new Set(restoredItemIds),
        });
      }

      resumeBulkMockupJob({
        parentId: this.props.parentId,
        // Called once per persisted job — creates a dedicated handler so that
        // each job independently tracks its own completion.
        makeStatusHandler: () => {
          this._activeJobCount++;
          return this._makeBulkStatusHandler(null);
        },
      }).catch((err) => {
        console.error('Failed to resume bulk mockup job:', err);
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('dragend', this.onDragEnd);
    if (this._addToClientCatalogResetTimeout) {
      clearTimeout(this._addToClientCatalogResetTimeout);
      this._addToClientCatalogResetTimeout = null;
    }
  }

  onEditItem(item_id) {
    const { dispatch, navigate } = this.props;
    const item = this.props.items.filter(i => i.item_id === item_id)[0] || {};
    if (item.hasInventoryBreakdowns) {
      dispatch(createEditInventoryBreakdownQuantityPopup(item, this.props.locked));
    } else if (this.props.is_aggregate_so && !this.props.locked) {
      dispatch(createValidateConfirmationPopup(() => {
        return navigate(this.props.location.pathname.replace(/\/+$/, '') + '/' + item_id);
      }, [], 'Are You Sure?', 'If you edit the quantity the count will not match the orders placed on the store. To increase the quantity, it is best to place an order through the store.'));
    } else {
      navigate(this.props.location.pathname.replace(/\/+$/, '') + '/' + item_id);
    }
  }

  onOpenMockupGenerator = (item_id) => {
    const item = this.props.items.find(i => i.item_id === item_id);
    if (item) {
      this.setState({ bulkMockupItems: [item] });
    }
  };

  _dispatchedBulkItemIds = new Set();

  // Number of bulk jobs currently in-flight (polling). Used to determine when
  // all concurrent jobs have finished so we can show the final banner.
  _activeJobCount = 0;

  // Accumulated results from all completed jobs within this session.
  _mergedBulkResult = null;

  /**
   * Creates a status-change handler for a single bulk job.
   *
   * jobItemIds: the item IDs submitted for this job (null when resuming and the
   * IDs are unknown — terminal cleanup falls back to generated_item_ids /
   * failed_items from the server response).
   */
  _makeBulkStatusHandler = (jobItemIds) => {
    let jobFinished = false;
    return (status, response) => {
      const normalized = (status === 'queued' || status === 'processing') ? 'processing' : status;
      const partiallyCompletedIds = new Set(Object.keys(response.item_data_by_item ?? {}));

      if (normalized !== 'processing' && !jobFinished) {
        jobFinished = true;
        this._activeJobCount = Math.max(0, this._activeJobCount - 1);

        // Merge this job's terminal result into the running totals.
        this._mergedBulkResult = {
          generated_item_ids: [
            ...new Set([
              ...(this._mergedBulkResult?.generated_item_ids ?? []),
              ...(response.generated_item_ids ?? []),
            ]),
          ],
          failed_items: {
            ...(this._mergedBulkResult?.failed_items ?? {}),
            ...(response.failed_items ?? {}),
          },
          item_data_by_item: {
            ...(this._mergedBulkResult?.item_data_by_item ?? {}),
            ...(response.item_data_by_item ?? {}),
          },
        };
      }

      const stillActive = this._activeJobCount > 0;

      this.setState(prev => {
        // Remove items completed in this polling cycle.
        let newGeneratingIds = new Set(
          [...prev.generatingItemIds].filter(id => !partiallyCompletedIds.has(id))
        );

        // On job termination, clear any remaining items for this job.
        if (normalized !== 'processing') {
          const allJobItemIds = new Set([
            ...(response.generated_item_ids ?? []),
            ...Object.keys(response.failed_items ?? {}),
            ...(jobItemIds ?? []),
          ]);
          allJobItemIds.forEach(id => newGeneratingIds.delete(id));
        }

        return {
          bulkMockupStatus: stillActive ? 'processing' : normalized,
          generatingItemIds: newGeneratingIds,
          ...(!stillActive && normalized !== 'processing' ? { bulkMockupResult: this._mergedBulkResult } : {}),
        };
      });

      if (response.item_data_by_item && Object.keys(response.item_data_by_item).length > 0) {
        this._dispatchBulkItemImages(response.item_data_by_item);
      }
      if (normalized !== 'processing' && !stillActive) {
        this.props.dispatch(createLoadOrder(this.props.order_id, true));
      }
    };
  };

  _dispatchBulkItemImages = (itemDataByItem) => {
    const { dispatch } = this.props;
    Object.entries(itemDataByItem).forEach(([itemId, itemData]) => {
      if (this._dispatchedBulkItemIds.has(itemId)) return;
      const { file, item_image, item_images } = itemData ?? {};
      if (!file?.file_id) {
        console.warn('[bulk mockup] Skipping item with missing file data:', itemId, itemData);
        return;
      }
      const normalizedItemImages = Array.isArray(item_images) ? item_images : Object.values(item_images ?? {});
      dispatch(createFinalizeUploadFile(file));
      dispatch(createFinalizeAddItemImage(item_image, normalizedItemImages));
      this._dispatchedBulkItemIds.add(itemId);
    });
  };

  onCopyItem(item_id, index, target_order, quantity, job_number) {
    const { dispatch, navigate } = this.props;
    if (target_order) {
      dispatch(createCopyItem(item_id, index, target_order.order_id, quantity));
      if (target_order.order_type === 'SALES ORDER') {
        navigate('/project/' + job_number + '/sales-order/' + target_order.form_number);
      } else {
        navigate('/project/' + job_number + '/' + target_order.order_type.toLowerCase() + '/' + target_order.form_number);
      }
    } else {
      dispatch(createCopyItem(item_id, index));
    }
  }

  onUpgradeItem(item, psProduct) {
    this.props.onUpgradeItem(item, psProduct);
  }

  onAddProductItem(index) {
    const { navigate } = this.props;
    if (Number.isInteger(parseInt(index, 10))) {
      navigate(`${this.props.location.pathname.replace(/\/+$/, '')}/add-product?index=${index}`);
    } else {
      navigate(`${this.props.location.pathname.replace(/\/+$/, '')}/add-product`);
    }
  }

  onDragEnd() {
    if (this.state.dragItem !== null && this.state.hoverIndex != -1) {
      let drag_obj = {
        id: this.state.dragItem,
        index: this.state.hoverIndex
      };
      this.onDropItem(drag_obj);
    }
  }

  onAddItem(index) {
    this.setState({
      dropdownOptions: this.getHeaderOptions(index),
    });
  }

  onAllItemSelector(parentType) {
    if(this.state.selectedItemIds.length !== 0) {
      this.setState({
        selectedItemIds: []
      });
    } else {
      this.setState({
        selectedItemIds: this.filteredItems.filter((i) => i.parent_type === parentType).map((i) => i.item_id)
      });
    }
  }

  handleContextMenu(index) {
    return e => {
      e.preventDefault();
      this.setState({
        dropdownOptions: this.getHeaderOptions(index, true),
      });
      this.dropdown.showDropdown(true, {
        top: e.clientY,
        left: e.clientX,
      });
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // temp hack to prevent redundant re-render, should achieve this by
    // clean unnecessary new object/function/array in props
    return nextState !== this.state || !(
      nextProps === this.props || _.every(nextProps, (v, k) => {
        return _.isEqual(this.props[k], v);
      })
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const items = this.getStateItemsfromProps(nextProps);
    if (!_.isEqual(items, this.state.items)) {
      this.setState({
        items,
      });
    }
  }

  getStateItemsfromProps({ items, order_type }) {
    this.filteredItems = getOrderItems({ items, order_type });
    return _.map(this.filteredItems, (i) => i.item_id);
  }

  getHeaderOptions(index, is_context_menu = false) {
    const { order_id, order_type, services, onAddTitleItem, onAddServiceItem, onAddArtworkPO, hasPresentationBuilderFlag } = this.props;
    const idx = BASE_ADD_INDEX !== index ? (index + (is_context_menu ? 0 : 1)) : null;
    const baseHandler = e => {
      this.dropdown.showDropdown(false);
    };
    let result = [];
    if (is_context_menu) {
      const item_id = this.state.items[index];
      result = [
        { key: 'COPY', value: 'Copy', onClick: e => { baseHandler(e); this.onCopyItem(item_id, idx + 1); } }
      ];
    }
    if (order_type === 'SALES ORDER') {
      return result.concat([
        { key: 'PRODUCT', value: 'Add Product', onClick: e => { baseHandler(e); this.onAddProductItem(idx); } },
        { key: 'SEPARATOR', value: 'Title', onClick: e => { baseHandler(e); onAddTitleItem(order_id, idx); } },
        ...services.map(s => Object.assign({}, s, { onClick: e => { baseHandler(e); onAddServiceItem(order_id, s.key, idx); } })),
        { key: 'ARTWORK_PO', value: 'Service PO', onClick: e => { baseHandler(e); onAddArtworkPO(order_id, idx); } },
        { key: 'SERVICE', value: 'Other Service', onClick: e => { baseHandler(e); onAddServiceItem(order_id, null, idx); } }
      ]);
    } else if (order_type === 'PRESENTATION') {
      return result.concat([
        { key: 'PRODUCT', value: 'Add Product', onClick: e => { baseHandler(e); this.onAddProductItem(idx); } },
        { key: 'SEPARATOR', value: 'Title', onClick: e => { baseHandler(e); onAddTitleItem(order_id, idx); } },
        hasPresentationBuilderFlag ? { key: 'BUILD_PRESENTATION', value: 'Build Presentation', onClick: e => { baseHandler(e); this.onOpenPresentationBuilder(); } } : null,
      ].filter(Boolean));
    } else if (order_type === 'COLLECTION') {
      return result.concat([
        { key: 'PRODUCT', value: 'Product', onClick: e => { baseHandler(e); this.onAddProductItem(idx); } },
        { key: 'SEPARATOR', value: 'Category', onClick: e => { baseHandler(e); onAddTitleItem(order_id, idx); } },
      ]);
    } else if (order_type === 'SHOP') {
      return result.concat([
        { key: 'PRODUCT', value: 'Add Product', onClick: e => { baseHandler(e); this.onAddProductItem(idx); } },
        { key: 'SEPARATOR', value: 'Title', onClick: e => { baseHandler(e); onAddTitleItem(order_id, idx); } },
      ]);
    } else {
      return result.concat([
        { key: 'PRODUCT', value: 'Add Product', onClick: e => { baseHandler(e); this.onAddProductItem(idx); } },
        { key: 'SEPARATOR', value: 'Title', onClick: e => { baseHandler(e); onAddTitleItem(order_id, idx); } },
        ...services.map(s => Object.assign({}, s, { onClick: e => { baseHandler(e); onAddServiceItem(order_id, s.key, idx); } })),
        { key: 'SERVICE', value: 'Other Service', onClick: e => { baseHandler(e); onAddServiceItem(order_id, null, idx); } }
      ]);
    }
  }

  onOpenPresentationBuilder() {
    const { navigate } = this.props;
    const hasBuilderFlags = this.props.hasPresentationBuilderFlag;
    if (!hasBuilderFlags) {
      return null;
    }
    navigate(`${this.props.location.pathname.replace(/\/+$/, '')}/builder`);
  }

  hasItem() {
    return 0 < this.state.items.length;
  }

  async handleAddToClientCatalog() {
    const { clientId } = this.props;
    const TIMEOUT_DELAY = 2000;
    const MAX_BULK_SIZE = 50;

    const { selectedItemIds, addToClientCatalogPhase, clientCatalogId } = this.state;

    if (selectedItemIds.length > MAX_BULK_SIZE) {
      toast.error(`You can only add up to ${MAX_BULK_SIZE} items at a time.`);
      return;
    }

    if (addToClientCatalogPhase === 'loading' || !clientId || selectedItemIds.length === 0) {
      return;
    }

    const itemIds = [...selectedItemIds];
    this.setState({ addToClientCatalogPhase: 'loading' });

    // after certain delay, reset button state and de-select successful items
    const resetCatalogButton = (itemIdsRemaining = []) => {
      if (this._addToClientCatalogResetTimeout) {
        clearTimeout(this._addToClientCatalogResetTimeout);
      }
      this._addToClientCatalogResetTimeout = setTimeout(() => {
        this._addToClientCatalogResetTimeout = null;
        this.setState({ selectedItemIds: [...itemIdsRemaining], addToClientCatalogPhase: 'idle' });
      }, TIMEOUT_DELAY);
    };

    const handleResponse = (addToClientCatalogResponse) => {
      const successfulIds = addToClientCatalogResponse?.successfulIds ?? [];
      const failedItemIdMap = addToClientCatalogResponse?.failedIds ?? {};
      const failedItemIds = Object.keys(failedItemIdMap);

      // show success
      if (successfulIds.length > 0) {
        this.setState({ addToClientCatalogPhase: 'success' });
      }

      // show failure toast, clear successful items but keep failed items selected.
      if (failedItemIds.length > 0) {
        toast.error(formatCatalogItemsFailureToast(failedItemIdMap));
        resetCatalogButton(failedItemIds);
      } else {
        // clear entire selection
        resetCatalogButton();
      }
    };

    try {
      let catalogId = clientCatalogId;
      if (!catalogId) {
        const { json: catalogJson } = await oauth('POST', 'catalogs', { client_id: clientId });
        catalogId = catalogJson?.catalog_id;
        if (!catalogId) {
          toast.error('Could not resolve client catalog.');
          this.setState({ addToClientCatalogPhase: 'idle' });
          return;
        }
        this.setState({ clientCatalogId: catalogId });
      }
      const { json: addToClientCatalogResponse } = await oauth('POST', `catalogs/${catalogId}/items`, { item_ids: itemIds });
      handleResponse(addToClientCatalogResponse);
    } catch (err) {
      // we have failed ids
      if (err?.json?.failedIds && Object.keys(err.json.failedIds).length > 0) {
        handleResponse(err.json);
        return;
      }

      // more generic error
      if (err?.json?.errors?.length > 0) {
        toast.error(err?.json?.errors[0]);
      } else {
        toast.error('Unexpected error occurred');
        console.error('Error when adding to client catalog: ', err);
      }
      this.setState({
        addToClientCatalogPhase: 'idle',
      });
    }
  }

  async handlePushToShopify(selectedItemIds, itemsWithoutVariants) {
    this.setState({
      showPushToShopifyWarnPopup: false,
      showPushToShopifyPopup: true,
      isPushingToShopify: true,
    });
    const itemsToPush = selectedItemIds.filter(
      itemId => !itemsWithoutVariants.includes(itemId)
    );
    try {
      await oauth("POST", "shopify-product-push", {
        item_ids: itemsToPush,
        shop_id: this.props.shopId
      });
      this.setState((prev) => ({
        showPushToShopifyPopup: false,
        shopifyPollKey: prev.shopifyPollKey + 1,
      }));
    } catch (error) {
      this.setState({showPushToShopifyErrorPopup: true, showPushToShopifyPopup: false, isPushingToShopify: false});
    }
  }

  handlePushToShopifyStatusChange = (status) => {
    this.setState((prev) =>{
      if (prev.pollingPushToShopifyStatus === status) return null;
      const isPollingActive = status === 'in_progress' || status === 'new';
      const isPollingCompleted = status === 'successful' || status === 'failed' || status === 'timed_out';
      return {
        pollingPushToShopifyStatus: status,
        isPushingToShopify: isPollingActive
          ? true
          : isPollingCompleted
            ? false
            : status === null && !prev.isPushingToShopify
              ? false
              : prev.isPushingToShopify,
      };
    });
  };

  renderHeader(display) {
    if ('PRESENTATION' === this.props.order_type || 'SHOP' === this.props.order_type) {
      switch (display) {
        case 'compact':
          return this.renderCompactPresentationHeader();
        case 'grid':
          return this.renderGridPresentationHeader();
        case 'detailed':
          return this.renderDetailedPresentationHeader();
        case 'artwork':
          return this.renderArtworkHeader();
        case 'comment':
          return this.renderEmptyHeader();
      }
    }
    switch (display) {
      case 'compact':
        return this.renderCompactHeader();
      case 'detailed':
        return this.renderDetailedHeader();
      case 'artwork':
        return this.renderArtworkHeader();
      case 'collection-compact':
        return this.renderCompactPresentationHeader();
      case 'collection-detailed':
        return this.renderCollectionHeader();
    }
  }

  renderAddItem(showTrigger = true) {
    const {
      dropdownOptions,
    } = this.state;
    const {
      identity,
      order_type,
      hasPresentationBuilderFlag,
    } = this.props;
    const isTenant = 'TENANT' === identity.company_type;

    let product = null;
    let separator = null;
    const rest = [];

    if (isTenant) {
      _.forEach(dropdownOptions, item => {
        if ('PRODUCT' === item.key) {
          product = item;
        } else if ('SEPARATOR' === item.key) {
          separator = item;
        } else if ('COPY' !== item.key) {
          rest.push(item);
        }
      });
    }

    return <div className="dropdown-holder" style={{ 'marginLeft': '0px' }}>
      {
        hasPresentationBuilderFlag && order_type === 'PRESENTATION' && <>
          <div style={{
            display: 'inline-block',
            padding: '0 5px 0 0',
            margin: '0 5px 0 0',
            height: 'auto',
            borderRight: '1px solid #D4D4D8',
          }}>
            <IconButton
              style={{ padding: '1px 21px' }}
              Icon={(props) => <SkuBot color={colors.primary1['70']} {...props} style={{ verticalAlign: 'middle', marginRight: '5px' }} size={'2xl'} />}
              onClick={this.onOpenPresentationBuilder}
            >Build with skubot</IconButton>
          </div>
        </>
      }
      {
        product && !this.props.hideAddItemActions && <IconButton Icon={AddIcon} onClick={product.onClick}>{product.value}</IconButton>
      }
      {
        separator && !this.props.hideAddItemActions && <IconButton variant='text' style={{ borderColor: 'transparent', background: 'transparent' }} Icon={AddIcon} onClick={separator.onClick}>{separator.value}</IconButton>
      }
      {
        !_.isEmpty(rest) && <DropdownMenu
          options={rest} >
          {showTrigger && !this.props.locked ?
            <MenuTrigger>
              <IconButton variant='text' style={{ borderColor: 'transparent', background: 'transparent' }} Icon={AddIcon} >Service</IconButton>
            </MenuTrigger> : null}
        </DropdownMenu>
      }
      {
        !_.isEmpty(dropdownOptions) && <DropdownMenu
          ref={(dropdown) => { this.dropdown = dropdown; }}
          onDropdownHide={() => this.onAddItem(BASE_ADD_INDEX)}
          options={dropdownOptions} >
          {!isTenant && showTrigger && !this.props.locked ?
            <MenuTrigger>
              <a className="button small"
                style={{ marginBottom: '5px' }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onAddItem(BASE_ADD_INDEX);
                }}>
                <i className="fi-plus" />&nbsp;&nbsp;Add
              </a>
            </MenuTrigger> : null}
        </DropdownMenu>
      }
    </div>;
  }

  renderEmptyHeader() {
    return (
      <thead style={{ height: 0 }}>
        <tr>
          <th>{this.renderAddItem(false)}</th>
        </tr>
      </thead>
    );
  }

  renderCompactPresentationHeader() {
    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary">
        <tr>
          <ItemListTHDescription hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
          {
            this.hasItem() && <th className="breakdown-count"># of Breakdowns</th>
          }
        </tr>
      </ItemListTableHeader>
    );
  }

  renderGridPresentationHeader() {
    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary">
        <tr>
          <ItemListTHDescription hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
        </tr>
      </ItemListTableHeader>
    );
  }

  renderDetailedPresentationHeader() {
    const { order_type, locked, mockupEnabled, isHeadless, externalStoreType, hasPushToShopifyCapability, hasShopifyIntegration, isPodShop } = this.props;
    const canUseBulkMockup = mockupEnabled && !isPodShop;
    const allowBulkUpdates = !locked && (order_type === 'PRESENTATION' || (order_type === 'SHOP' && (canUseBulkMockup || (hasPushToShopifyCapability && hasShopifyIntegration))));
    const itemsOption = this.filteredItems.filter((i) => i.parent_type === 'OPTION');
    const isShopifyShop = order_type === 'SHOP' && +isHeadless === 1 && externalStoreType === 'SHOPIFY';
    const shopifyCapability = isShopifyShop && hasPushToShopifyCapability && hasShopifyIntegration;

    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary">
        {shopifyCapability && (
          <tr>
            <th colSpan={5} style={{height: 55}}>
              <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: 12}}>
                <InfoIcon size="medium" color={colors.secondary4['80']}/>
                <Typography.Text fontSize={'16px'} fontWeight={400} style={{ marginBottom: 0, lineHeight: 0 }}>
                  One-way push to Shopify. Products labeled “Missing Variant(s) / SKU(s)” must have at least one variant with a SKU before they can be pushed.
                </Typography.Text>
              </div>
            </th>
          </tr>
        )}
        <tr>
          <ItemListTHDescription colSpan={allowBulkUpdates ? 5 : 1} hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
          {!allowBulkUpdates && this.hasItem() && <>
              <th className="title"></th>
              <th className="quantity">Units</th>
              <th className="margin">Margin</th>
              <th className="amount">Amount</th>
            </>
          }
        </tr>
        {allowBulkUpdates && this.hasItem() &&
          <tr>
            <th style={{height: 55}}>
              {
                !isPodShop &&
                (shopifyCapability || this.state.items.length > 1) &&
                <LabeledCheckbox
                  indeterminate={this.state.selectedItemIds.length > 0 && this.state.selectedItemIds.length < itemsOption.length}
                  checked={this.state.selectedItemIds.length > 0 && this.state.selectedItemIds.length === itemsOption.length}
                  labelStyle={{ marginBottom: 0 }}
                  label={`Select ${this.state.selectedItemIds.length === 0 ? 'All' : 'None'}`}
                  onClick={() => this.onAllItemSelector('OPTION')}
                />
              }
            </th>
            <th className="title"></th>
            <th className="quantity">Units</th>
            <th className="margin">Margin</th>
            <th className="amount">Amount</th>
          </tr>
        }
      </ItemListTableHeader>
    );
  }

  renderCollectionHeader() {
    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary">
        <tr>
          <ItemListTHDescription hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
          {
            this.hasItem() && <>
              <th className="title"></th>
              <th className="quantity">Units</th>
              <th className="amount">Amount</th>
            </>
          }
        </tr>
      </ItemListTableHeader>
    );
  }

  renderCompactHeader() {
    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary">
        <tr>
          <ItemListTHDescription hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
          {
            this.hasItem() && <>
              <th className="quantity">Units</th>
              <th className="margin">Margin</th>
              <th className="tax">Tax</th>
              <th className="amount">Amount</th>
            </>
          }
        </tr>
      </ItemListTableHeader>
    );
  }

  renderDetailedHeader() {
    const { order_type, locked } = this.props;
    const allowBulkUpdates = order_type === 'SALES ORDER' && !locked && this.props.checkBulkUpdateMarginStatus;
    const itemsOption = this.filteredItems.filter((i) => i.parent_type === 'PRODUCT');

    return (
      <ItemListTableHeader hasItem={this.hasItem()} className="item-summary detailed">
        <tr>
          <ItemListTHDescription colSpan={allowBulkUpdates ? 7 : 1} hasItem={this.hasItem()} className="description">{this.renderAddItem()}</ItemListTHDescription>
          {!allowBulkUpdates && this.hasItem() && <>
              <th className="title">Item</th>
              <th className="quantity">Units</th>
              <th className="amount">Price</th>
              <th className="margin">Margin</th>
              <th className="tax">Tax</th>
              <th className="amount">Amount</th>
            </>
          }
        </tr>
        {allowBulkUpdates && this.hasItem() &&
          <tr>
            <th>
              {
                this.state.items.length > 1 &&
                <LabeledCheckbox
                  indeterminate={this.state.selectedItemIds.length > 0 && this.state.selectedItemIds.length < itemsOption.length}
                  checked={this.state.selectedItemIds.length > 0 && this.state.selectedItemIds.length === itemsOption.length}
                  labelStyle={{ marginBottom: 0 }}
                  label={<a style={{ color: colors.primary1['70'] }}>Select {this.state.selectedItemIds.length === 0 ? 'All' : 'None'}</a>}
                  onClick={() => this.onAllItemSelector('PRODUCT')}
                />
              }
            </th>
            <th className="title">Item</th>
            <th className="quantity">Units</th>
            <th className="amount">Price</th>
            <th className="margin">Margin</th>
            <th className="tax">Tax</th>
            <th className="amount">Amount</th>
          </tr>
        }
      </ItemListTableHeader>
    );
  }

  renderArtworkHeader() {
    return (
      <ItemListTableHeader isArtwork={true} hasItem={this.hasItem()} className="item-summary">
        <tr>
          <ItemListTHDescription isArtwork={true} hasItem={this.hasItem()}>{this.renderAddItem()}</ItemListTHDescription>
          {
            this.hasItem() && <th style={{ textAlign: 'left' }}>Artwork</th>
          }
        </tr>
      </ItemListTableHeader>
    );
  }

  onMoveItem(dragIndex, hoverIndex) {
    const { items } = this.state;
    const dragItem = items[dragIndex];
    const item_copy = items.slice();
    item_copy.splice(dragIndex, 1);
    item_copy.splice(hoverIndex, 0, dragItem);
    this.setState({
      hoverIndex,
      items: item_copy,
      dragItem: dragItem
    });
  }

  onDropItem(item) {
    const origIndex = _.findIndex(this.filteredItems, { item_id: item.id });
    if (_.isInteger(origIndex) && _.isInteger(item.index) && origIndex != item.index) {
      const origItem = this.filteredItems[origIndex];
      this.props.onReorderItem(item.id, origItem.display_order)(item.index);
    }
    this.setState({ hoverIndex: -1, dragItem: null });
  }

  getLastItemIndexForTitle(titleIndex, allItems) {
    const laterItems = allItems.slice(titleIndex + 1).filter(i => typeof i !== 'undefined').filter(i => i.parent_type === 'SEPARATOR');
    const lastItem = laterItems.length > 0 ? laterItems[0] : allItems[allItems.length - 1];
    let lastItemIndex = null;
    let offset = laterItems.length > 0 ? 1 : 0;
    for (let index = 0; index < allItems.length; index++) {
      if (allItems[index].item_id === lastItem.item_id) {
        lastItemIndex = index - offset;
        break;
      }
    }
    return lastItemIndex;
  }

  validateItemForPushToShopify(){
    const { items } = this.props;
    const selectedItemIds = this.state.selectedItemIds;
    const itemsWithoutVariantOrSku = items.filter(item => item.parent_type !== 'PRODUCT' && ((!item.variants || item.variants.length === 0 || item.variants.some(v => v.external_id == null || v.external_id === ''))));
    const itemsWithoutVariantOrSkuIds = itemsWithoutVariantOrSku.map(item => item.item_id);
    const selectedItemsWithoutVariantsOrSku = selectedItemIds.filter(itemId => itemsWithoutVariantOrSku.some(item => item.item_id === itemId));
    const selectedItemsWithoutVariantsOrSkuCount = selectedItemsWithoutVariantsOrSku.length;

    return { selectedItemsWithoutVariantsOrSku, selectedItemsWithoutVariantsOrSkuCount, itemsWithoutVariantOrSkuIds };
  }

  // keeping this filter helper for further implementation when dropdown desing is ready and MVP is completed
  filterSetupRequiredItemsForShopify() {
    const { items, filterSetupRequiredItems } = this.state;
    const {itemsWithoutVariantOrSkuIds} = this.validateItemForPushToShopify();
    if (filterSetupRequiredItems) {
      this.setState({
        items: items.filter(itemId => itemsWithoutVariantOrSkuIds.includes(itemId))
      });
    } else {
      this.setState({
        items: this.getStateItemsfromProps(this.props)
      });
    }
  }

  render() {
    const {
      order_type,
      items,
      onUpdateItem,
      onDeleteItem,
      onUpdateItemThumb,
      onDeleteItemThumb,
      display,
      hidden_filter_status,
      onCreateEditServicePopup,
      onCreateEditArtworkPOPopup,
      onCreateCopyItemPopup,
      onBulkUpdateMargin,
      locked,
      identity,
      add_to_order,
      job_number,
      hasPSUpgradeProductEnabled,
      mockupEnabled,
      isHeadless,
      externalStoreType,
      hasPushToShopifyCapability,
      hasShopifyIntegration,
      shopId,
      isPodShop,
    } = this.props;
    const item_ids = this.state.items;
    const selectedItemIds = this.state.selectedItemIds;
    const hoverIndex = this.state.hoverIndex;
    const { generatingItemIds } = this.state;
    const visible_items = item_ids.map(item_id => items.filter(o => o.item_id === item_id)[0]);

    const hasCapability = capability => identity.capabilities.includes(capability);
    const canUseBulkMockup = mockupEnabled && !isPodShop;

    const isShopifyShop = order_type === 'SHOP' && +isHeadless === 1 && externalStoreType === 'SHOPIFY';
    const shopifyCapability = isShopifyShop && hasPushToShopifyCapability && hasShopifyIntegration;

    const base_item_props = {
      onMove: this.onMoveItem,
      onDrop: this.onDropItem,
      onAddItem: this.onAddItem,
      onEditItem: this.props.hideAddItemActions ? null : this.onEditItem,
      onDeleteItem,
      onCopyItem: this.onCopyItem,
      onUpdateItem,
      hasCapability,
      onUpgradeItem: this.onUpgradeItem,
      order_type,
      locked,
      detailed: 'detailed' === display || 'collection-detailed' === display,
      display,
      add_to_order,
      job_number,
      canDrag: !(locked || ['artwork', 'comment'].includes(display)),
    };

    const class_map = SUMMARY_CLASS_MAP[display];

    const { selectedItemsWithoutVariantsOrSku, selectedItemsWithoutVariantsOrSkuCount, itemsWithoutVariantOrSkuIds } = this.validateItemForPushToShopify();

    const handleShopifyOnclick = selectedItemsWithoutVariantsOrSkuCount > 0
    ? () => this.setState({ showPushToShopifyWarnPopup: true })
    : () => this.handlePushToShopify(selectedItemIds, selectedItemsWithoutVariantsOrSku);

    const content = (
      <>
        {this.renderHeader(display)}
        {visible_items.length ? visible_items.map((i, idx) => {
          if (i.hidden == 1 && 'active' === hidden_filter_status) {
            return null;
          }
          const item_props = Object.assign({
            className: (idx === hoverIndex ? 'hover' : '') +
              (hoverIndex !== -1 ? ' dragging' : '') +
              ('SEPARATOR' === i.parent_type ? ' title-item' : ''),
            id: i.item_id,
            index: idx,
            item: i,
            display: display,
            isTitle: 'SEPARATOR' === i.parent_type,
            lastItemIndex: 'SEPARATOR' !== i.parent_type ? null : this.getLastItemIndexForTitle(idx, visible_items),
            handleContextMenu: this.handleContextMenu(idx)
          }, base_item_props);

          const extra_props =
            'SERVICE' === i.parent_type ?
              { onEditItem: onCreateEditServicePopup } :
              'SEPARATOR' === i.parent_type ?
                { onEditItem: null, dropdownOptions: this.getHeaderOptions(idx), onUpdateItemThumb, onDeleteItemThumb, } :
                'ARTWORK_PO' === i.parent_type ?
                  { onEditItem: onCreateEditArtworkPOPopup } :
                  'OPTION' === i.parent_type ?
                    { onCopyOptionItem: onCreateCopyItemPopup, ...(canUseBulkMockup && { onOpenMockupGenerator: this.onOpenMockupGenerator, mockupGeneratingStatus: generatingItemIds.has(i.item_id) ? 'configuring' : null }), isPodShop: this.props.isPodShop } :
                    'PRODUCT' === i.parent_type ?
                      (() => {
                        const isUpgradeEligible = hasPSUpgradeProductEnabled &&
                          i.promo_api_name &&
                          i.item_sku &&
                          i.copied_from !== 'ps-products';

                        const product = isUpgradeEligible
                          ? this.props.convertibleProducts?.find(c =>
                            c.promo_api_name === i.promo_api_name &&
                            c.ps_product_id === i.item_sku
                          ) || null
                          : null;

                        const status = this.props.upgradeFailedByItemId?.[i.item_id]
                          ? 'failed'
                          : ['PENDING', 'PROCESSING'].includes(this.props.upgradingByItemId?.[i.item_id]?.status)
                            ? 'upgrading'
                            : 'available';

                        return {
                          upgradeInfo: product ? { product, status } : null,
                          ...(canUseBulkMockup && { onOpenMockupGenerator: this.onOpenMockupGenerator, mockupGeneratingStatus: generatingItemIds.has(i.item_id) ? 'configuring' : null }),
                          isPodShop: this.props.isPodShop,
                        };
                      })() :
                      {};

          const itemSelected = selectedItemIds.includes(i.item_id);
          const canSelect = order_type === 'PRESENTATION' ||
            this.props.checkBulkUpdateMarginStatus ||
            (canUseBulkMockup && ['PRESENTATION', 'SHOP'].includes(order_type)) ||
            shopifyCapability;
          if (canSelect && [ 'OPTION', 'PRODUCT' ].includes(i.parent_type)) {
            extra_props.onSelectItem = () => {
              if(itemSelected) {
                this.setState({
                  selectedItemIds: selectedItemIds.filter((itemId) => itemId !== i.item_id)
                });
              } else {
                selectedItemIds.push(i.item_id);
                this.setState({
                  selectedItemIds: selectedItemIds
                });
              }
            };

            extra_props.itemSelected = itemSelected;
          }

          if (+isHeadless === 1){
            extra_props.isHeadless = +isHeadless === 1;
          }

          if (shopifyCapability){
            extra_props.showShopifyMissingVariantOrSkuBar = itemsWithoutVariantOrSkuIds.includes(i.item_id);
          }

          const ItemSummaryComponent = class_map[i.parent_type];
          if (ItemSummaryComponent) {
            return <ItemSummaryComponent key={i.item_id} {...item_props} {...extra_props} />;
          }
        }) : <ProductSearchCallout />}
      </>
    );

    const selectedItemsCount = selectedItemIds.length;
    const onSetMarginClick = () => {
      this.setState({
        showSetBulkMarginPopup: true
      });
    };

    const onAIMockupsClick = () => {
      const selectedItems = this.filteredItems.filter(
        (item) => selectedItemIds.includes(item.item_id)
      );
      if (selectedItems.length > 0) {
        this.setState({ bulkMockupItems: selectedItems });
      }
    };

    const AIMockupsButton = () => {
      return (
        <IconButton
          onClick={onAIMockupsClick}
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        ><MagicIcon size="small" color='white' />
         AI Configure</IconButton>
      );
    };

    const SetMarginButton = () => {
      return (
        <IconButton
          onClick={onSetMarginClick}
        >Set Margin</IconButton>
      );
    };

    const isPushingToShopify =
      this.state.isPushingToShopify ||
      this.state.pollingPushToShopifyStatus === 'new' ||
      this.state.pollingPushToShopifyStatus === 'in_progress';

    const PushToShopifyButton = () => {
      return (
        <IconButton
          onClick={handleShopifyOnclick}
          disabled={isPushingToShopify || (selectedItemsCount - selectedItemsWithoutVariantsOrSkuCount <= 0)}
        >
          {isPushingToShopify ? 'Pushing...' : 'Push to Shopify'}
        </IconButton>
      );
    };

    const showBulkClientCatalog =
      this.props.hasClientCatalogBeta &&
      this.props.hasAddCatalogItemCapability &&
      this.props.clientId;

    const addCatalogPhase = this.state.addToClientCatalogPhase;

    const AddToClientCatalogButton = () => {
      return (
        addCatalogPhase === 'success' ? (
          <>
            <CheckmarkIcon size="large" color='white' style={{ marginRight: "-1em" }} />
            <span style={{ color: 'white', fontWeight: 600, fontSize: 18, lineHeight: '69px', marginBottom: 0 }}>Added to client catalog</span>
          </>
        ) : (
          <IconButton
            onClick={this.handleAddToClientCatalog}
            variant='primary'
            style={{width: '180px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          >
            {addCatalogPhase === 'loading' ? (
              <SkubotSpinner skubot={false} size="button" color={colors.white} />
            ) : (
              'Add to client catalog'
            )}
          </IconButton>
        )
      );
    };

    const actionBarDesc = isPushingToShopify ?
      'Pushing to Shopify...' :
      `${selectedItemsCount} product${selectedItemsCount === 1 ? '' : 's'} selected`;

    const selectedItemsNavbar = selectedItemsCount === 0 ? null :
      <BulkActionBar
        selected={selectedItemIds}
        prepareLabel={() => {
          return <p style={{
            color: 'white',
            fontWeight: 600,
            fontSize: 18,
            lineHeight: '69px',
            marginBottom: 0,
          }}>{actionBarDesc}</p>;
        }}

        actions={[
          ...(canUseBulkMockup ? [AIMockupsButton] : []),
          ...(this.props.checkBulkUpdateMarginStatus ? [SetMarginButton] : []),
          ...(showBulkClientCatalog ? [AddToClientCatalogButton] : []),
          ...(shopifyCapability ? [PushToShopifyButton] : []),
        ]}
      />;

    const bulkMarginPopup = !this.state.showSetBulkMarginPopup ? null :
      <SetBulkMarginPopup
          checkBulkUpdateMarginStatus={this.props.checkBulkUpdateMarginStatus}
          selectedItems={this.filteredItems.filter((item) => selectedItemIds.includes(item.item_id))}
          orderCurrencyId={this.props.order_currency_id}
          orderType={this.props.order_type}
          onSetMarginClick={(margin, includeRunCharges) => {
            onBulkUpdateMargin(
              this.props.order_id,
              selectedItemIds,
              margin,
              includeRunCharges,
            );
          }}
          onClose={(done) => {
            this.setState({
              showSetBulkMarginPopup: false
            });
            if (done) {
              this.setState({
                selectedItemIds: []
              });
            }
          }}
      />;

    const bulkMockupPopup = !this.state.bulkMockupItems ? null :
      <BulkMockupGeneratorPopup
        items={this.state.bulkMockupItems}
        accountId={this.props.accountId}
        parentId={this.props.parentId}
        parentType={this.props.parentType}
        proofOptions={this.props.proofOptions}
        onClose={() => this.setState({ bulkMockupItems: null })}
        onGenerate={(config) => {
          const allIds = [
            ...config.readyItems.map(i => i.item_id),
            ...config.decoratedItems.map(i => i.item_id),
          ];
          this._activeJobCount++;
          // Union — keep badges for any items from earlier jobs still generating.
          this.setState(prev => ({
            bulkMockupItems: null,
            bulkMockupStatus: 'processing',
            generatingItemIds: new Set([...prev.generatingItemIds, ...allIds]),
            selectedItemIds: [],
          }));
          startBulkMockupGeneration(config).then(({ bulk_job_id }) => {
            persistBulkJobItems(bulk_job_id, allIds);
            pollBulkMockupJob({
              bulkJobId: bulk_job_id,
              parentId: this.props.parentId,
              onStatusChange: this._makeBulkStatusHandler(allIds),
            });
          }).catch((err) => {
            console.error('Failed to start bulk mockup generation:', err);
            this._activeJobCount = Math.max(0, this._activeJobCount - 1);
            if (this._activeJobCount === 0) {
              this.setState({ bulkMockupStatus: null, generatingItemIds: new Set() });
            }
          });
        }}
      />;

    const pushToShopifyWarnPopup = !this.state.showPushToShopifyWarnPopup ? null :
      <PushToShopifyWarnPopup
        selectedItemsWithoutVariantsCount={selectedItemsWithoutVariantsOrSkuCount}
        selectedItemCount={selectedItemsCount}
        onClose={() => {
          this.setState({
            showPushToShopifyWarnPopup: false
          });
        }}
        onPushToShopify={() => this.handlePushToShopify(selectedItemIds, selectedItemsWithoutVariantsOrSku)}
      />;

    const pushToShopifyPopup = !this.state.showPushToShopifyPopup ? null :
      <PushToShopifyPopup
        onClose={() => {
          this.setState({
            showPushToShopifyPopup: false
          });
        }}
      />;

    const pushToShopifyErrorPopup = !this.state.showPushToShopifyErrorPopup ? null :
      <PushToShopifyErrorPopup
        onClose={() => {
          this.setState({
            showPushToShopifyErrorPopup: false
          });
        }}
      />;

    const { bulkMockupStatus, bulkMockupResult } = this.state;
    const bannerBase = {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '12px 16px',
      borderRadius: 4,
      marginBlock: 8,
      fontSize: 14,
    };
    const bulkMockupBanner = bulkMockupStatus === 'processing' ? (
      <div style={{ ...bannerBase, background: '#EBF8FF', color: '#2B6CB0' }}>
        <MagicIcon size='medium' style={{ flexShrink: 0 }} />
        <span>Your products are being configured. Feel free to navigate away from this screen.</span>
      </div>
    ) : bulkMockupStatus === 'completed' ? (
      <div style={{ ...bannerBase, background: '#E6FAF4', color: '#276749' }}>
        <MagicIcon size='medium' style={{ flexShrink: 0 }} />
        <span style={{ flex: 1 }}>{(() => {
          const genCount = bulkMockupResult?.generated_item_ids?.length ?? 0;
          const failCount = Object.keys(bulkMockupResult?.failed_items ?? {}).length;
          const total = genCount + failCount;
          if (failCount === 0) {
            return total > 0 ? `All ${total} products have now been configured.` : 'Your products have now been configured.';
          }
          return `${genCount} of ${total} products have now been configured. ${failCount} product${failCount !== 1 ? 's' : ''} could not be processed.`;
        })()}</span>
        <span
          onClick={() => this.setState({ bulkMockupStatus: null, bulkMockupResult: null })}
          style={{ cursor: 'pointer', fontWeight: 600, marginLeft: 8 }}
        >Dismiss</span>
      </div>
    ) : bulkMockupStatus === 'failed' ? (
      <div style={{ ...bannerBase, background: '#FFF5F5', color: '#C53030' }}>
        <MagicIcon size='medium' style={{ flexShrink: 0 }} />
        <span style={{ flex: 1 }}>Something went wrong configuring your products. Please try again.</span>
        <span
          onClick={() => this.setState({ bulkMockupStatus: null, bulkMockupResult: null })}
          style={{ cursor: 'pointer', fontWeight: 600, marginLeft: 8 }}
        >Dismiss</span>
      </div>
    ) : null;

    const podSetupBanner = isPodShop ? (
      <div style={{
        ...bannerBase,
        background: '#F8F8F8',
        color: colors.secondary4['80'],
        gap: 8,
        padding: 8,
      }}>
        <InfoIcon size="medium" color={colors.secondary4['80']} />
        <span>Products with incomplete setup are not visible in this Shop.</span>
      </div>
    ) : null;

    const shopifyPollEnabled = shopifyCapability && !!shopId;

    const pushToShopifyPollBridge = shopifyPollEnabled ? (
      <PushToShopifyPollBridge
        shopId={shopId}
        onStatusChange={this.handlePushToShopifyStatusChange}
        enabled={shopifyPollEnabled}
        pollKey={this.state.shopifyPollKey}
      />
    ) : null;

    return (
      'grid' !== display ? (
        <>
          {podSetupBanner}
          {canUseBulkMockup && bulkMockupBanner}
          <table className={'products-table full-breakdowns'}>
            {content}
          </table>
          {selectedItemsNavbar}
          {bulkMarginPopup}
          {bulkMockupPopup}
          {pushToShopifyWarnPopup}
          {pushToShopifyPopup}
          {pushToShopifyErrorPopup}
          {pushToShopifyPollBridge}
        </>
      ) : (
        <div className={`products-table display-${display}`}>
          {podSetupBanner}
          {canUseBulkMockup && bulkMockupBanner}
          {content}
          {bulkMockupPopup}
          {pushToShopifyPollBridge}
        </div>
      ));
  }
}

const mapStateToProps = (state, ownProps) => {
  const projects = state.entities.projects;
  const hasProjects = projects && Object.values(projects).length > 0;
  const project = hasProjects ? Object.values(projects)[0] : null;
  const add_to_order = hasProjects ? getMostRecentUnlockedOrder(state, { project_id: project.job_id }) : null;
  const job_number = project?.job_number ?? null;

  const shops = state.entities.shops;
  const shopId = shops ? Object.keys(shops)[0] ?? null : null;
  const shop = shops ? Object.values(shops)[0] : null;
  const isPodShop = !!shop && isPODShop(shop);
  const isHeadless = shops && shops[shopId]?.is_headless;
  const externalStoreType = shops && shops[shopId]?.external_store_type;

  const accountId = project?.account_id ?? '';
  const parentId = project?.job_id ?? shopId ?? '';
  const parentType = project?.job_id ? 'JOB' : (shopId ? 'SHOP' : 'ITEM');

  const { hasUserFlags, hasCapabilities } = getIdentityUtils(state.identity);
  const mockupEnabled = aiMockupAndRewriterEnabled(state.identity);
  const hasClientCatalogBeta = hasUserFlags('CLIENT-CATALOG');
  const hasAddCatalogItemCapability = hasCapabilities('ADD-CATALOG-ITEM');
  const hasPushToShopifyCapability = hasCapabilities('HAS-PUSH-TO-SHOPIFY');
  const hasShopifyIntegration = hasCapabilities(["FEATURE-ADVANCED", "FEATURE-ENTERPRISE"], true);
  const hasPresentationBuilderFlag = hasUserFlags([PRESENTATION_BUILDER_AGENT_FLAG, SKUBOT_ENABLED]);

  return {
    identity: state.identity,
    add_to_order,
    job_number,
    accountId,
    parentId,
    parentType,
    mockupEnabled,
    isPodShop,
    isHeadless,
    externalStoreType,
    hasClientCatalogBeta,
    hasAddCatalogItemCapability,
    hasPushToShopifyCapability,
    hasShopifyIntegration,
    proofOptions: getProofOptions(state),
    shopId,
    hasPresentationBuilderFlag,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const updateItem = createUpdate('item', {
    request: actions.UPDATE_ITEM_REQUEST,
    success: actions.UPDATE_ITEM_SUCCESS,
    failure: actions.UPDATE_ITEM_FAILURE,
    failure_message: 'Unable to update item'
  });
  const reorderItem = createUpdate('item', {
    request: actions.REORDER_ITEM_REQUEST,
    success: actions.REORDER_ITEM_SUCCESS,
    failure: actions.REORDER_ITEM_FAILURE,
    failure_message: 'Unable to update item'
  });

  return {
    dispatch,
    onUpdateItem: (item_id, field, previous_value, field_lock = 'unit_cost') => value => {
      dispatch(updateItem(item_id, field, previous_value, value, { field_lock }));
    },
    onUpdateItemThumb: (item_id) => {
      dispatch(createUploadProductImagePopup(item_id));
    },
    onDeleteItemThumb: (itemImage) => {
      dispatch(createDeleteItemImage(itemImage.item_image_id));
    },
    onDeleteItem: item_id => {
      if (ownProps.is_aggregate_so && !ownProps.locked) {
        dispatch(createValidateConfirmationPopup(() => {
          return dispatch(createDeleteItem(item_id));
        }, [], 'You Sure?', 'Sales order items created from checkouts should not be deleted.'));
      } else {
        dispatch(createValidateConfirmationPopup(() => {
          return dispatch(createDeleteItem(item_id));
        }, []));
      }
    },
    onAddTitleItem: (order_id, index, shop_id = null) => {
      const kwargs = {};
      if (shop_id) {
        kwargs['with_shop_id'] = shop_id;
      }
      dispatch(createAddItem(
        order_id, 'SEPARATOR', undefined, undefined, undefined, index,
        null, null, null, null, null, 'all', '0', kwargs));
    },
    onAddServiceItem: (order_id, service_id, index) => {
      dispatch(createAddItem(order_id, 'SERVICE', service_id, undefined, undefined, index));
    },
    onReorderItem: (item_id, previous_value) => value => {
      dispatch(reorderItem(item_id, 'display_order', previous_value, value));
    },
    onCreateEditServicePopup: (item_id) => {
      dispatch(createEditServicePopup(item_id));
    },
    onAddArtworkPO: (order_id, index) => {
      dispatch(createAddItem(
        order_id, 'ARTWORK_PO', undefined, undefined, undefined, index));
    },
    onCreateEditArtworkPOPopup: (item_id, parent_id) => {
      dispatch(createEditArtworkPOPopup(item_id, parent_id));
    },
    onCreateCopyItemPopup: (item, add_to_order) => {
      dispatch(createCopyItemPopup(item, add_to_order));
    },
    onBulkUpdateMargin: (orderId, itemIds, margin, includeRunCharges) => {
      dispatch(bulkUpdateMargin(orderId, itemIds, margin, includeRunCharges));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemList));
